import { render } from "./DefaultLayout.vue?vue&type=template&id=4db468e4&ts=true"
import script from "./DefaultLayout.ts?vue&type=script&lang=ts&external"
export * from "./DefaultLayout.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__